import { CommandService } from "Service/CommandService";
import { BaseService } from "Service/BaseService";
import { Configuration } from "Configuration";

import { AppContext, Util } from "Core";
import { ExportContextParameter, ExportClient, ExportColumn, ExportResult, BaseResult } from "./Client";
import { PageContext } from "Core/PageContext";

/**
 * Service for exporting grid data.
 * @hidden
 */
export class ExportService extends BaseService {
    /**
     * Export a grid to excel.
     * @param gridId Grid ID.
     * @param filterId Filter ID.
     * @param textBlockCategory TextBlockCategory.
     * @param commandOption CommandOption.
     */
    public export(gridId: number, filterId: number, textBlockCategory: string, commandOption: any, columns: ExportColumn[]): Promise<ExportResult> {
        let exportParam: ExportContextParameter = {
            GridID: gridId,
            TextBlockCategory: textBlockCategory,
            Columns: columns,
        };
        if (filterId != null) {
            exportParam.FilterID = filterId;
        }
        let parameters = $.extend(exportParam, CommandService.getRequestParameters());
        parameters.Options = commandOption;
        parameters.TimezoneIANA = AppContext.current.environment.ClientTimeZone;
        exportParam.ApplicationParameters["IsExcelExport"] = "1";

        let client = new ExportClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        // client.get(gridId, param)
        // return this.handleResult(
        //     new Promise<{ [key: string]: CommandResult }>((resolve, reject) => {
        //         let xhr = client.post(
        //             gridId,
        //             param,
        //             (res) => resolve(res),
        //             (exception, reason) => reject(exception)
        //         );
        //         // token.onCancelled((reason) => {
        //         //     xhr.abort();
        //         //     reject(reason);
        //         // });
        //     })
        // );
        return this.handleResult(new Promise<BaseResult>((resolve, reject) => {
             /*let xhr =*/ client.export(
                AppContext.current.environment.LanguageCode,
                exportParam,
                (res) => {
                    res = AppContext.handleServiceResult(res);
                    Util.saveFileBase64(
                        res.File,
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
                        PageContext.getMappingName() + ".xlsx"
                    );
                    resolve(res);
                },
                (exception, reason) => {
                    AppContext.handleServiceError(exception);
                    reject(reason);
                }
            );
            // token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        }));
    }
}
